import algorithms from './algorithms/index';
import formValidation, { Plugin, Status } from './core/index';
import filters from './filters/index';
import plugins from './plugins/index';
import utils from './utils/index';
import validators from './validators/index';
const locales = {};
export { algorithms, formValidation, filters, locales, plugins, utils, validators, Plugin, Status, };



//////////////////
// WEBPACK FOOTER
// ./node_modules/formvalidation/dist/es6/index.js
// module id = xiXx
// module chunks = 58